import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';
import { getFormTableInitialValues2 } from 'components/BusinessToolForm/utils/helpers';

export const EFFICIENCY_FORM_NAMES = {
  EFFICIENCY_VARIANTS: 'efficiencyVariants',
  EFFICIENCY_TABLE: 'efficiencyTable',
  ANTICIPATED_OUTCOME: 'anticipatedOutcome',
} as const;

export const efficiencyVariants = [
  'Inventory turnover ratio',
  'Accounts receivable turnover ratio',
  'Accounts payable turnover ratio',
  'Non-current assets turnover ratio',
];

//  ---- COMMON ----
export interface IEfficiencyFormValuesType {
  [EFFICIENCY_FORM_NAMES.EFFICIENCY_VARIANTS]: string[];
  [EFFICIENCY_FORM_NAMES.EFFICIENCY_TABLE]: IPeriodsTableRow[];
  [EFFICIENCY_FORM_NAMES.ANTICIPATED_OUTCOME]: string;
}

export const efficiencyInitialValues = {
  [EFFICIENCY_FORM_NAMES.EFFICIENCY_VARIANTS]: efficiencyVariants,
  [EFFICIENCY_FORM_NAMES.EFFICIENCY_TABLE]: getFormTableInitialValues2(
    efficiencyVariants.length,
    initialPeriodsTableRow,
  ),
  [EFFICIENCY_FORM_NAMES.ANTICIPATED_OUTCOME]: '',
};
